'use strict';

import { Button } from '../../interfaces/buttons/Button';
import {BaseElement} from "../../interfaces/BaseElement";
import {menuHandler} from "../menu";
import {getUrlParam, isOptionsCardOpened} from '../../../functions';
import {components, isMobile, isNoMenu, settingsData} from "../../../settings";
import {SwipeScript} from "../../controls/swipe";
import {McIDElement} from "./McID";
import { DreamsPreloader } from '../../components/preloader/DreamsPreloader';
import { McIdDreamsForm } from '../../components/form/McIdLeadForm';

export class CustomerContactNow extends Button {
    #positions = config.features.customerContactNow?.position || [];
    static closeBtnColor = config.features.customerContactNow?.closeBtnColor || '#000000';
    static link = config.features.customerContactNow?.iframe || '';
    static externalParams = '';
    static isActive = config.features.customerContactNow?.active || false;

    constructor (location) {
        const buttonText = settingsData.isConferenceHost
            ? 'contactUs'
            : window.innerHeight < 360 ? 'Buy' : 'Buy now';
        super(buttonText);

        // const isPrepaymentButton = Boolean(document.querySelector('.prepayment-btn'));
        const isRemoveCondition = isMobile ? !config['crmProjectSettings'].general.menuItems.contactUs :
            (!this.#positions.includes(location) || !CustomerContactNow.isActive || CustomerContactNow.link === '')
            || config.features?.customerContactNow?.removeLocation && config.features.customerContactNow.removeLocation.includes(location);
        if (isRemoveCondition || isNoMenu) {
            this.remove();
            return;
        }

        const prevBtn =
          document.querySelector('.options-card')?.querySelector('[data-button-type="customerContactNow"]');
        if (prevBtn)
            prevBtn.remove();

        this
          .addClass('button', 'customer-contact-now-btn', `${location}__customer-contact-now-btn`)
          .addAttribute('data-button-type', 'customerContactNow')
          .event('click', this.clickHandler.bind(this));
    }

    clickHandler(e) {
        e.stopPropagation();

        if (isMobile) {
            const mcid = document.querySelector('.additional-menu__item .mc-id-contacts');
            const dropdown = mcid.querySelector('.dropdown');
            if (isOptionsCardOpened()) {
                const currentOptionsCard = document.querySelector('.options-card');
                let mcidClone = currentOptionsCard.querySelector('.mc-id-contacts');
                if (!mcidClone) {
                    const bumper = currentOptionsCard.querySelector('.options-card__bumper');
                    mcidClone = mcid.cloneNode(true);
                    mcidClone.style.height = 0;
                    mcidClone.style.width = 0;
                    bumper.appendChild(mcidClone);
                }

                const cloneDropdown = mcidClone.querySelector('.dropdown');
                const cloneLogo = mcidClone.querySelector('.mc-id__logo-wrapper');
                const cloneStatus = mcidClone.querySelector('.mc-id__consolto-status');
                const buttonsWrapper = currentOptionsCard.querySelector('.cards-buttons-wrapper');
                const cloneDropdownCurtain = cloneDropdown.querySelector('.dropdown__curtain');
                cloneDropdown.classList.add('--show-dropdown');
                cloneLogo.classList.add('hidden');
                cloneStatus.classList.add('hidden');
                buttonsWrapper?.classList.add('hidden');

                SwipeScript(cloneDropdown);
                cloneDropdownCurtain.addEventListener('swiped-down', () => {
                    cloneDropdown.classList.remove('--show-dropdown');
                    buttonsWrapper?.classList.remove('hidden');
                });

                for (const handler in McIDElement.handlers) {
                    const elementsForHandler = [...mcidClone.querySelectorAll(`[data-role="${handler}"]`)];
                    console.log(elementsForHandler)
                    elementsForHandler.forEach(element => {
                        element.addEventListener('click', McIDElement.handlers[handler]);
                    });
                    // if (elementForHandler)
                    //     elementForHandler.addEventListener('click', McIDElement.handlers[handler]);
                }

                const navigateButtonHandler = () => {
                    const long = config.localization.longitude;
                    const lat = config.localization.latitude;
                    window.open(`https://maps.google.com/?saddr=My+Location&daddr=${lat},${long}`, '_blank');
                }
                const navigateButton = mcidClone.querySelector('.contact-us__preview-navigate');
                if (navigateButton)
                    navigateButton.addEventListener('click', navigateButtonHandler);

                const callNowClickHandler = () => {
                    const originalCallNowElement = mcid.querySelector('[data-role="callNow"]');
                    const tel = originalCallNowElement.getAttribute('data-tel');
                    const href = 'tel:' + tel;
                    window.open(href,'_blank');
                }
                const callNowButton = mcidClone.querySelector('[data-role="callNow"]');
                if (callNowButton)
                    callNowButton.addEventListener('click', callNowClickHandler);

                const letsTalkButton = mcidClone.querySelector('[data-role="consolto"]');
                if (letsTalkButton) {
                    const letsTalkNewButton = components.contactWidget.createOptionButton();
                    letsTalkNewButton.className = 'mc-id__contact-widget__btn language-string icon-video-call dropdown__content-element mc-id__content-element';
                    letsTalkButton.replaceWith(letsTalkNewButton)
                }
            } else {
                mcid?.click();
                dropdown?.click();
            }
        } else {
            if (CustomerContactNow.link === '') {
                menuHandler({target:{dataset:{menuItem: 'contactUs', isFromApplyNow: true}}});

                return;
            }

            new McIdDreamsForm();
            // this.container = new BaseElement()
            //   .addClass('customer-contact-now__container')
            //   .appendTo(document.body);
            // this.iframeContainer = new BaseElement()
            //   .addClass('customer-contact-now__iframe-container')
            //   .appendTo(this.container.DOMElement);
            //
            // this.#addPreloader(this.iframeContainer.DOMElement);
            //
            // new BaseElement('button')
            //   .addClass('customer-contact-now__close-btn','icon-close')
            //   .event('click', this.#closeListener.bind(this))
            //   .appendTo(this.iframeContainer.DOMElement)
            //   .DOMElement.style.color = CustomerContactNow.closeBtnColor;
            // const link = new URL(CustomerContactNow.link);
            // if (!link.search) {
            //     link.search = '?' + CustomerContactNow.externalParams.slice(1);
            // } else {
            //     link.search += CustomerContactNow.externalParams;
            // }
            //
            // new BaseElement('iframe')
            //   .addClass('customer-contact-now-iframe')
            //   .addAttribute('src', link.href)
            //   .appendTo(this.iframeContainer.DOMElement)
            //   .DOMElement.onload = () => this.preloader.remove();
        }
    }

    // #closeListener() {
    //     this.container.remove();
    // }
    //
    // #addPreloader(parent, customClass) {
    //     this.preloader = new BaseElement()
    //       .addClass('customer-contact-now-loader', 'tumbs__preloader', `${customClass}`)
    //       .appendTo(parent);
    // }

    static addExternalParams() {
        if (!config.features.customerContactNow?.active
            || !config.features.customerContactNow?.externalParams?.length) return;

        const externalParams = config.features.customerContactNow.externalParams;
        externalParams.forEach(param => {
            const value = getUrlParam(param);
            if (value) {
                CustomerContactNow.externalParams += `&${param}=${value}`;
            }
        });
    }
}


export class CustomerContactNowIframe {
    constructor (parent) {
        this.parent = parent;
    }
    
    create() {
        if (!CustomerContactNow.isActive || CustomerContactNow.link === '')
            return;
    
        const root = document.querySelector(':root');
        root.style.setProperty('--customerContactNowCloseBtnColor', CustomerContactNow.closeBtnColor);
        
        const container = new BaseElement()
            .addClass('customer-contact-now__container')
            .appendTo(this.parent);
    
        const iframeContainer = new BaseElement()
            .addClass('customer-contact-now__iframe-container')
            .appendTo(container.DOMElement);
    
        const preloader = new DreamsPreloader(container.DOMElement)
            .absolute()
            .substrate()
            .show();
    
        const url = new URL(CustomerContactNow.link);
        if (!url.search) {
            url.search = '?' + CustomerContactNow.externalParams.slice(1);
        } else {
            url.search += CustomerContactNow.externalParams;
        }
    
        new BaseElement('iframe')
            .addClass('customer-contact-now-iframe')
            .addAttribute('src', url.href)
            .appendTo(iframeContainer.DOMElement)
            .DOMElement.onload = () => preloader.remove();
    }
}
